import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { RichText } from "../../../element";
import { Figure } from "./Figure";
import { AccordionItemContentWrapper } from "./AccordionItem.styles";
export var AccordionItemContent = function(param) {
    var content = param.content, image = param.image;
    return /*#__PURE__*/ _jsxs(AccordionItemContentWrapper, {
        children: [
            /*#__PURE__*/ _jsx(RichText, {
                content: content,
                rules: {
                    columns: [
                        [
                            10
                        ],
                        [
                            11,
                            "sm"
                        ],
                        [
                            8,
                            "lg"
                        ],
                        [
                            7,
                            "lg",
                            {
                                override: true
                            }
                        ]
                    ]
                }
            }),
            /*#__PURE__*/ _jsx(Figure, {
                content: {
                    image: image
                },
                rules: {
                    columns: [
                        [
                            10
                        ],
                        [
                            11,
                            "sm"
                        ],
                        [
                            5,
                            "lg"
                        ]
                    ]
                }
            })
        ]
    });
};
